import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material'
import { Grid, Typography } from '../../../../../components/mui/Core/index'

function GenericInputCardRenderer({ title, children }) {
  const theme = useTheme()
  const cardContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: `1px 1px ${theme.palette.shadow.dark}`,
    backgroundColor: theme.palette.common.white,
    border: 'none',
    textAlign: 'left',
    textTransform: 'none',
  }

  return (
    <Grid container sx={cardContainerStyle}>
      <Grid size={12}>
        <Typography variant='cardHeader'>{title}</Typography>
      </Grid>
      <Grid size={12}>{children}</Grid>
    </Grid>
  )
}

GenericInputCardRenderer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default GenericInputCardRenderer
